import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { ThemeProvider } from '@material-ui/styles'
import CssBaseline from '@material-ui/core/CssBaseline'

import App from 'App'
import theme from 'theme'
import CircularProgress from 'components/shared/CircularProgress'
import * as serviceWorker from 'serviceWorker'
import store, { history } from 'redux/store'
import 'http/auth'

import './index.scss'

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <ThemeProvider theme={theme}>
        <div style={{ display: 'flex', minHeight: '100vh' }}>
          <CssBaseline />
          <CircularProgress />
          <App />
        </div>
      </ThemeProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
